function InitlializeRandomSampleLists() {
    $('.random-sample-update').click(function (e) {

        var arr = new Array(),
            redirect = $(this).data('redirect');

        $('.random-sample-lists').each(function (index, element) {
            if ($(element).find(':checkbox').is(":checked")) {
                var universalCount = $(element).find('.universal-count').text().trim();
                var requestedCount = $(element).find('.requested-count .singleTextBox').val();
                var keyCode = $(element).find('.key-code .singleTextBox').val();
                var geoDescription = $(element).find('.geo-description').text().trim();

                var obj = { selectedNth: true, GeoDescription: geoDescription, UniverseCount: universalCount, RequestedCount: requestedCount, Keycode: keyCode };
                arr.push(obj);
            }
        });
        
        if (arr.length < 1) {
            return false;
        }

        jQuery.ajax({
            url: "/RandomSampleNth/ContinueSample",
            cache: false,
            traditional: true,
            contentType: 'application/json; charset=utf-8',
            type: 'POST',
            data: JSON.stringify(arr),
            success: function(data) {
                if (data.Success) {
                    if (redirect) {
                        window.location.href = data.RedirectUrl;
                    } else {
                        $('.total-requested-count').html(data.TotalRequestedCount);
                        $('.random-sample-lists').each(function (index, element) {
                            $(element).find('.actual-count').html($(element).find('.requested-count .singleTextBox').val());
                        });
                    }
                }
            },
            async: true
        });

        return false;
    });
}

$('#clearAll').on('click', function() {
    var holdCheckbox = jQuery("#tableContainer INPUT[type='checkbox']");
    var boxValue = clearAll.innerHTML;
    var chkValue = false;
    if (boxValue === "Clear all")
        chkValue = false;
    else
        chkValue = true;

    for (var i = 0; i < holdCheckbox.length; i++) {
        holdCheckbox[i].checked = chkValue;
    }

    if (clearAll.innerHTML === "Clear all")
        clearAll.innerHTML = "Check all";
    else
        clearAll.innerHTML = "Clear all";

});

